import { Navigate, Route, Routes } from 'react-router-dom';

import { AppLayout } from './components/AppLayout.tsx';
import { ConviteDeInstalacao } from './components/ConviteDeInstalacao.tsx';
import { DicaGlobal } from './components/DicaGlobal';
import { ProtectedRoute } from './components/ProtectedRoute.tsx';
import { BankAccountsPage } from './pages/BankAccountsPage.tsx';
import { BatchBillingPage } from './pages/BatchBillingPage.tsx';
import { BoletosPage } from './pages/BoletosPage.tsx';
import { CategoriesPage } from './pages/CategoriesPage.tsx';
import { CertificatesPage } from './pages/CertificatesPage.tsx';
import { ClientDetailPage } from './pages/ClientDetailPage.tsx';
import { ClientsPage } from './pages/ClientsPage.tsx';
import { ContractsPage } from './pages/ContractsPage.tsx';
import { ConvitePage } from './pages/ConvitePage.tsx';
import { DashboardPage } from './pages/DashboardPage.tsx';
import { EsqueciSenhaPage } from './pages/EsqueciSenhaPage.tsx';
import { FinancialPage } from './pages/FinancialPage.tsx';
import { InvoicesPage } from './pages/InvoicesPage.tsx';
import { IssuerCompaniesPage } from './pages/IssuerCompaniesPage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { PartnersPage } from './pages/PartnersPage.tsx';
import { ProposalsPage } from './pages/ProposalsPage.tsx';
import { RedefinirSenhaPage } from './pages/RedefinirSenhaPage.tsx';
import { RemindersPage } from './pages/RemindersPage.tsx';
import { ServicesPage } from './pages/ServicesPage.tsx';
import { UsersPage } from './pages/UsersPage.tsx';

export function App() {
  return (
    <>
      <DicaGlobal />
      <ConviteDeInstalacao />
      <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/esqueci-senha" element={<EsqueciSenhaPage />} />
      <Route path="/convite" element={<ConvitePage />} />
      <Route path="/redefinir-senha" element={<RedefinirSenhaPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        <Route path="certificates" element={<CertificatesPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="batch-billing" element={<BatchBillingPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="financial" element={<FinancialPage />} />
        <Route path="boletos" element={<BoletosPage />} />
        <Route path="reminders" element={<RemindersPage />} />
        <Route path="bank-accounts" element={<BankAccountsPage />} />
        <Route path="proposals" element={<ProposalsPage />} />
        <Route
          path="services"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN', 'ADMIN']}>
              <ServicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="categories"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN', 'ADMIN']}>
              <CategoriesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="partners"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN', 'ADMIN']}>
              <PartnersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="issuer-companies"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN', 'ADMIN', 'OPERATOR']}>
              <IssuerCompaniesPage />
            </ProtectedRoute>
          }
        />
        {/* Compat: rota antiga redireciona */}
        <Route path="tenant-config" element={<Navigate to="/issuer-companies" replace />} />
        <Route
          path="users"
          element={
            <ProtectedRoute roles={['SUPER_ADMIN', 'ADMIN']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
